// Version pins for the legal-acceptance gate.
//
// Bump these when a new `{tos,privacy}-v<N>.md` file lands in
// packages/legal/content/. Never edit a published markdown file
// in place — once a version string is written into profiles.tos_version
// on a real user row, git's content hash for that version is the audit
// record. A typo fix in the committed markdown breaks that contract.
// See CLAUDE.md → "Legal documents" for the full rule.

export const LATEST_TOS_VERSION = "1.2";
export const LATEST_PRIVACY_VERSION = "2.1";

// Accepted only at Lifetime checkout, outside the gate, so a bump never re-walls anyone.
// `lifetime-terms-v<N>.md` is immutable once published.
export const LATEST_LIFETIME_TERMS_VERSION = "1.1";
